import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; // Or use @highcharts/react components
import 'highcharts/modules/exporting';
import { formatNumber } from '../../../../../Common/FormatNumber';

interface ChartProps {
  title: string;
  height: number;
}

const PriceMode: React.FC<ChartProps> = ({ title, height = 345 }) => {
  const [categories, setCategories] = React.useState([]);
  const [currentGP, setCurrentGP] = React.useState([]);
  const [lastYrGP, setLastYrGP] = React.useState([]);
  const [products, setProducts] = React.useState([]);

  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
  React.useEffect(() => {
    fetch(`/dashboard/price-mode/?entity_id=${localStorage.getItem('entity_id')}`)
      .then(response => response.json())
      .then(data => 
        setTimeout(() => {
          setCategories(data.categories);
          setLastYrGP(data.last_yr_gp);
          setCurrentGP(data.current_gp);
          setProducts(data.products);
        }, 100)
      );

    const handleResize = () => {
      if (chartComponentRef.current && chartComponentRef.current.chart) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const options: Highcharts.Options = {
        chart: {
            type: 'column',
            zooming: {
                type: 'xy' as const
            }
        },
        title: {
            text: title,
            align: 'left'
        },
        
        xAxis: {
            crosshair: true,
            accessibility: {
                description: ''
            },
            // minRange: 10,
            categories: categories,
            title: {
                text: 'Customers',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            labels: {
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: 'Gross Profit (%)',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            labels: {
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
        },
        tooltip: {
            valueSuffix: ' %',
            formatter: function(this: Highcharts.Point) {
                return `<span style="font-family: Trebuchet MS;">${this.series.name}: ${this.y.toFixed(2)}%<br/>Product: ${products[this.index]}</span>`;
            },
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            {
                type: 'column',
                name: 'Current Gross Profit',
                data: currentGP
            },
            {
                type: 'column',
                name: 'Previous Gross Profit',
                data: lastYrGP
            }
        ]
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate={true}
                exportEnabled={true}
                ref={chartComponentRef}
                containerProps={{ style: { width: '100%', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
            />
        </div>
    );
};

export default PriceMode;
